import React from 'react';
import { useSelector } from 'react-redux';
import { DirectionSelector } from './DirectionSelector/DirectionSelector';
import { SubgroupSelector } from './SubgroupSelector/SubgroupSelector';
import { ServicesSelector } from './ServicesSelector/ServicesSelector';
import { BranchSelector } from './BranchSelector/BranchSelector';
import { getSelectedService } from '../../store/selectors';
import { ServiceDescription } from '../ServiceDescription/ServiceDescription';

export const ServiceSelector = () => {
    const selected = useSelector(getSelectedService);
    return <>
        <DirectionSelector/>
        <SubgroupSelector/>
        <ServicesSelector/>
        <ServiceDescription/>
        {selected?.selected?.services && <BranchSelector/>}
    </>;
};
